import { createFileRoute } from '@tanstack/react-router'
import { HousesPage } from '@/features/houses/components/houses-page'

export const Route = createFileRoute('/_authenticated/dashboard/houses/')({
  component: HousesPage,
})
